import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-user-affiliate-ratio-dialog',
  templateUrl: './user-affiliate-ratio-dialog.component.html',
  styleUrls: ['./user-affiliate-ratio-dialog.component.scss'],
})
export class UserAffiliateRatioDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<UserAffiliateRatioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: UserApiService
  ) {}

  ngOnInit(): void {
    this.findUserAffiliateRatios();
  }

  ratios: any[] = [];
  async findUserAffiliateRatios() {
    try {
      const r = await this.api.findUserAffiliateRatios();
      this.ratios = r.data;
    } catch (error) {}
  }
}
